module.exports = __webpack_public_path__ + "static/media/IconTemplates_-56.d9f3a22e.svg";